import { ColumnsType } from 'antd/es/table'
import { generateColumnTitle } from 'src/helpers/utils'
import { AssessmentScore } from 'src/store/APIs/types'

import { strings } from './strings'
import { PromisGlobalScoreDataIndex } from './types'

export const promisGlobalScoreColumns: ColumnsType<AssessmentScore> = [
  {
    ...generateColumnTitle(
      PromisGlobalScoreDataIndex.category,
      strings.category,
    ),
  },
  {
    ...generateColumnTitle(PromisGlobalScoreDataIndex.raw, strings.raw),
  },
  {
    ...generateColumnTitle(PromisGlobalScoreDataIndex.t_score, strings.t_score),
    render(value) {
      return value ?? '-'
    },
  },
]
